"use strict";
/**
 * Account-level settings, stored per Group (an agency's account) in `group.settings`.
 *
 * Stored values are partial: a setting nobody has changed isn't stored, so `resolveAccountSettings`
 * (@shared/utils) fills in these defaults and the default can change without a migration.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_SETTING_DEFAULTS = exports.DOCUMENT_RETENTION_DAY_CHOICES = void 0;
exports.DOCUMENT_RETENTION_DAY_CHOICES = [30, 60, 90, 180, 365];
exports.ACCOUNT_SETTING_DEFAULTS = {
    documentRetentionDays: 90,
};
//# sourceMappingURL=account-settings-types.js.map